<div id="page-top" aria-live="polite" tabindex="-1">{{ page?.name }}</div>
<core-header></core-header>

@if ({ isTop: isTopNav$ | async }; as navigation) {
    <div class="page-wrapper view-wrapper">
        <div class="page-inner site-wrapper">
            <div class="page-content-wrapper wrapper site-content">
                <main
                    #main
                    [ngClass]="{
                        'page-content--no-hero':
                            isTopNavTransparent &&
                            (!heroImagesEnabled || (page && !page.meta.icon) || (post && !post.data.image)),
                    }"
                    class="page-content container-fluid p-0 mobile-padding category-{{ category || 'default' }}"
                    id="main-content"
                    tabindex="-1">
                    <!-- If not homepage and automaticPageBreadcrumbs is enabled, show breadcrumbs-->
                    @if (pageNeedsAutomaticBreadcrumbs()) {
                        <div class="automatic-breadcrumbs" [style.background-color]="automaticBreadcrumbBgColor">
                            <div class="automatic-breadcrumbs__content">
                                <core-block-breadcrumbs [page]="page"></core-block-breadcrumbs>
                            </div>
                        </div>
                    }

                    @if ((page && page.meta.icon) || (post && post.data.image)) {
                        <div class="header-block">
                            <!-- Hero image for all pages that aren't Home and a Life Moments/Journey pages.
                            Uses just one main image which can be positioned using iconAlign meta for background-position. -->
                            @if (heroImagesEnabled) {
                                <div [class]="`header-image header-image--overlay-${headerImageOverflowBehaviour}`">
                                    <div
                                        class="header-image__inner"
                                        [ngStyle]="{
                                            backgroundPosition:
                                                page && page.meta.iconAlign ? page.meta.iconAlign : 'center center',
                                        }"
                                        [style.background-image]="getBackgroundImage() | cdnBackground">
                                        <div [ngClass]="{ loaded: delayedLoaded }" class="header-overlay"></div>
                                    </div>
                                    @if (headerImageGradient; as gradient) {
                                        <div
                                            [style.background]="
                                                'linear-gradient(90deg, ' +
                                                gradient.from +
                                                ' 0%, ' +
                                                gradient.to +
                                                ' 100%)'
                                            "
                                            class="header-image-gradient"></div>
                                    }
                                </div>
                            }
                        </div>
                        <core-block-notification-bar></core-block-notification-bar>
                    }
                    <div [class]="containerClass">
                        <router-outlet></router-outlet>
                    </div>
                    @if (notificationsEnabled && !navigation.isTop) {
                        <core-notifications></core-notifications>
                    }
                </main>
                <core-footer></core-footer>
            </div>
            <core-back-to-top></core-back-to-top>
            <core-demo-config-toggle></core-demo-config-toggle>
        </div>
        <span class="page-overlay"></span>
    </div>
    @if (isChatEnabled) {
        <core-block-chat
            [demoMode]="false"
            [botName]="botName()"
            [botAvatar]="botAvatar()"
            [startingMessage]="botStartingMessage()"></core-block-chat>
    }
}
